import React from 'react';
import { BeforeAfterAndBonuses, GuaranteeAndCost, PainAndTransformation, ProductOverview, SocialAndFAQ, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-primary selection:text-white" data-id="element-0" data-mp="2mm2ji848kh09">
      <MetaPixel data-id="element-1" data-mp="31brzvakwgrl4" />
      <TopBar data-id="element-2" data-mp="31c9u61o04vqe" />
      <main data-id="element-3" data-mp="31ctfztgrw49p">
        <Hero data-id="element-4" data-mp="31cjk5p91r2w3" />
        <Testimonials data-id="element-5" data-mp="2wka0gqyiyz29" />
        <PainAndTransformation data-id="element-6" data-mp="2wiyy8vkq9zd9" />
        <ProductOverview data-id="element-7" data-mp="2wip7h5ruzo6i" />
        <BeforeAfterAndBonuses data-id="element-8" data-mp="28ufpyg1ohml6" />
        <Pricing data-id="element-9" data-mp="28tmej1rry8wp" />
        <SocialAndFAQ data-id="element-10" data-mp="28t4k8aooa4rf" />
        <GuaranteeAndCost data-id="element-11" data-mp="28sbcb6dz997p" />
      </main>
      <Footer data-id="element-12" data-mp="23vunsb2v8su3" />
      <FloatingElements data-id="element-13" data-mp="23u9t8lgjx9w8" />
      <noscript data-id="element-14" data-mp="23utadzydnu97">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-15" data-mp="23t8gmcjw0fce" />
      </noscript>
    </div>;
}